import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Breadcrumb, Anchor, Row, Col, Carousel, Tabs, message } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { baseIframeUrl, request } from "@/utils/request";
import moment from 'moment';
import "./index.less";
import Config from "@/config/config";
import night from '@/assets/night.png';
import day from '@/assets/day.png';
import rest from '@/assets/rest.png';
import save from '@/assets/save.png';
import save_f from '@/assets/save_f.png';
import { getUser } from "@/utils";
import address from '@/assets/address.png'
import restaurant from '@/assets/restaurant.png';

const { Link } = Anchor;

export default function Detail() {
    const navigate = useNavigate();
    const location = useLocation();
    // const detail = location.state || {};
    const searchParams = new URLSearchParams(location.search);
    const [detail, setDetail] = useState({});
    const [imgs, setImgs] = useState([]);
    const [visitList, setVisitList] = useState([])
    const onAnchorChange = (e) => {
        console.log(e);
        console.log(detail);
    };
    const fetchData = async () => {
        try {
            const response = await request.get((sessionStorage.getItem('token')?'restaurant/login-detail?id=':'restaurant/detail?id=') + searchParams.get("id") + "&platform=web");
            setDetail(response.data || {});
            setImgs(response.data.cover)
            // let date = response.data.sub_dates;
            // if (date.length > 0) {
            //     let validate = moment(date[date.length - 1]).valueOf() > moment().valueOf()
            //     if (!validate) {
            //         setCanSub(false)
            //     }
            // }

            // if (response.data.prize_enable===1){
            //     let condition1 = moment(response.data.prize_start_at*1000).valueOf() < moment().valueOf()
            //     let condition2 = moment(response.data.prize_end_at*1000).valueOf() > moment().valueOf()
            //     let validate = condition1 && condition2
            //     if (!validate) {
            //         setCanSub(false)
            //     }
            // }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };
    const getItems = () => {
        if (visitList.length === 0) {
            return [
                {
                    "key": "1",
                    label: '套餐详情',
                },
                {
                    "key": "2",
                    label: '预约说明',
                },
                {
                    "key": "3",
                    label: '取消费率说明',
                },
                {
                    "key": "4",
                    label: '餐厅说明',
                },
            ]
        } else {
            return [
                {
                    "key": "1",
                    label: '套餐详情',
                },
                {
                    "key": "2",
                    label: '预约说明',
                },
                {
                    "key": "3",
                    label: '取消费率说明',
                },
                {
                    "key": "4",
                    label: '餐厅说明',
                },
                {
                    "key": "5",
                    label: '探店报道',
                },
            ]
        }


    }
    const getVisit = async () => {
        try {
            const response = await request.get('visit/list?page=1&page_size=100&visit_type=2&restaurant_id=' + searchParams.get('id'));
            setVisitList(response.data || [])
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    }
    const onChange = (key) => {
        console.log(key)
        document.getElementsByClassName('ant-anchor-link-title')[key - 1].click();
    }
    const collectFn = (value) => {
        request.post('restaurant/update-collect', {
            collect: value,
            id: detail.id
        }).then(r => {
            if (r.code) {
                message.error(r.msg)
                return;
            }
            if (value) {
                message.success('收藏成功')
            } else {
                message.success('取消收藏')
            }
            setTimeout(() => {
                fetchData()
            }, 500)
        })
    }
    useEffect(() => {
        window.scrollTo(0, 0)
        fetchData();
        getVisit()
    }, []);

    return (
        <div className="content-detail">
            <div className="detail-title">
                <div className="detail-title-box">
                    <Breadcrumb separator="">
                        {sessionStorage.getItem("mbx") === null && <Breadcrumb.Item href="/">主页</Breadcrumb.Item>}
                        {sessionStorage.getItem("mbx") === 'main' && <Breadcrumb.Item href="/">主页</Breadcrumb.Item>}
                        {sessionStorage.getItem("mbx") === 'canteen' && <Breadcrumb.Item href="/canteen">餐厅</Breadcrumb.Item>}

                        <Breadcrumb.Separator>
                            <RightOutlined />
                        </Breadcrumb.Separator>
                        <Breadcrumb.Item>餐厅详情</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
            </div>
            <div className="detail-container-header">
                <div className="detail-container-box">
                    <div className="header-img">
                        <Carousel autoplay>
                            {imgs.length && imgs.map((item) => {
                                return (
                                    (<div className="header-img">
                                        <img src={Config.imgPrefix + item} width="100%" height="100%"
                                            style={{ objectFit: "cover" }} alt="" />
                                    </div>)
                                )
                            })}
                        </Carousel>

                    </div>
                    <div className="info-content">
                        <div className="title">{detail.name}</div>
                        <div className='region'>
                            <div style={{display:'flex',alignItems:'center'}}><img src={address} alt="" className='icon' />{detail.region}</div>
                            <div style={{display:'flex',alignItems:'center',marginLeft:'10px'}}>
                                <img src={restaurant} alt=""  className='icon'/>
                                {
                                detail?.category_list?.map((v,i) => {
                                    return <div className='tag'>{v.name}
                                        {
                                            i !== detail?.category_list?.length - 1 && <span>·</span>
                                        }
                                    </div>
                                }
                                )}
                            </div>

                        </div>
                        <div className='price'>
                            {
                                !!(detail.lunch_price * 1) && <div className="time">
                                    <img src={day} className="icon" />
                                    JPY {detail.lunch_price} ~
                                </div>
                            }

                            {
                                !!(detail.supper_price * 1) && <div className='time'>
                                    <img src={night} className='icon' />
                                    JPY {detail.supper_price} ~
                                </div>
                            }

                        </div>
                        {
                            detail.legal_holiday && <div className='price'>
                                <div className='time'>
                                    <img src={rest} className='icon' />
                                    {detail.legal_holiday}
                                </div>
                            </div>
                        }
                        {
                            detail?.tag && <div className='tags'>
                                {
                                    detail?.tag?.map(v => {
                                        return <div className='tagItem'>{v}</div>
                                    })
                                }
                            </div>
                        }
                        <div className='desc'>
                            <div className='title'>{detail.announcement_title}</div>
                            <div className='desc-content' dangerouslySetInnerHTML={{ __html: detail.announcement_content }}></div>
                        </div>
                    </div>
                    <div className="honors">
                        {
                            detail.honor?.map(v => {
                                return <img className='honor-log' src={Config.imgPrefix + v.cover} />
                            })
                        }
                    </div>
                </div>
            </div>
            <div className="detail-box">
                <div className="content-tab-box" style={{ boxShadow: "none", paddingTop: "0" }}>
                    <div
                        className="content-tabs"
                        style={{
                            paddingLeft: "20px",
                            display: "none"
                        }}
                    >
                        <Anchor
                            affix={false}
                            direction="horizontal"
                            onChange={onAnchorChange}
                            offsetTop={120}
                        >
                            <Link
                                href="#package_desc"
                                title="套餐"
                            />
                            {detail.prize_enable === 1 &&
                                <Link
                                    href="#prize"
                                    title="抽选活动"
                                />
                            }
                            <Link
                                href="#sub_desc"
                                title="预约说明"
                            />
                            <Link
                                href="#cancel_rule"
                                title="取消费率说明"
                            />
                            <Link
                                href="#rest_desc"
                                title="餐厅说明"
                            />
                            <Link
                                href="#visit_desc"
                                title="探店报道"
                            />
                        </Anchor>

                    </div>
                    <div className="detail-tabs">
                        <Tabs defaultActiveKey="1" items={getItems()} indicatorSize={200} onChange={onChange} size="large"
                            // renderTabBar={renderTabBar}
                            tabBarStyle={{
                                width: "100%",
                                fontSize: "16px",
                                color: '#666666',
                                borderBottom: "2px solid rgba(0,0,0,0.098)"
                            }}
                            tabBarGutter={10}
                        />
                    </div>
                    <div>
                        <div id="package_desc" className="canting">
                            <div className="canting-title">套餐</div>
                            <div className="canting-content">
                                {
                                    detail?.meal?.map(v => {
                                        return <div className='item'>
                                            <div className='name'>{v.name}</div>
                                            <div className='price'>
                                                <div >JPY{v.price}/人</div>
                                                <div style={{ marginLeft: '40px' }}>押金 ￥{v.deposit}/人</div>
                                            </div>
                                            <div className="detail" dangerouslySetInnerHTML={{ __html: v.detail?.replace(/ /g, '&nbsp;').replace(/\n|↵/g, '<br/>') }}></div>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                        {/* {detail.prize_enable === 1 &&
                                <div id="prize" className="canting" >
                                    <div className="canting-title" >抽选活动
                                    </div>
                                    <div className="canting-content">
                                        {detail.prize_enable === 1}
                                        <div>
                                            <div >
                                                <div style={{ color: "#000" }}>活动时间: <span style={{ color: "#666666" }}>{moment(detail.prize_end_at * 1000).unix() < moment(new Date()).unix() ? "已结束" : ""}</span></div>
                                                <div style={{ color: "#666666" }}>
                                                    {moment(detail.prize_start_at * 1000).format("YYYY年MM月DD日")}-{moment(detail.prize_end_at * 1000).format("YYYY年MM月DD日")}
                                                </div>
                                                <div>
                                                    <span
                                                        style={{ color: "#666666" }}>中奖人在{moment(detail.sub_dates[0]).format("YYYY年MM月DD日")} {detail.sub_time[0]}可前往餐厅就餐</span>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: "14px", color: "#000" }}>
                                                活动说明:
                                                <div style={{ color: "#666666" }}>
                                                    {detail.prize_rule}
                                                </div>
                                            </div>
                                            {
                                                (detail.prize_member.length > 0) &&
                                                <>
                                                    <div style={{ marginTop: "30px", color: "#000" }}>
                                                        中奖名单:
                                                    </div>
                                                    <div className="prize-member-content">
                                                        {detail.prize_member.map((item, index) => {
                                                            return (
                                                                <>
                                                                    <div className="prize-member-item">
                                                                        <div className="prize-member-item-name"
                                                                            style={{ borderTop: "none" }}>{item.name}</div>
                                                                        <div className="prize-member-item-mobile">{item.mobile}</div>
                                                                    </div>
                                                                </>
                                                            )
                                                        })}
                                                    </div>
                                                </>
                                            }



                                        </div>
                                    </div>
                                </div>
                            } */}
                        <div id="sub_desc" className="canting">
                            <div className="canting-title">预约说明</div>
                            <div className="canting-content" dangerouslySetInnerHTML={{ __html: detail?.reservation_instruction }}>
                                {/* {detail?.reservation_instruction?.split('\n').map(v => {
                                    return <p>{v}</p>
                                })} */}
                            </div>
                        </div>
                        <div id="cancel_rule" className="canting">
                            <div className="canting-title">取消费率说明</div>
                            <div className="canting-content">
                                {detail.cancellation_rate_desc && detail.cancellation_rate_desc.map((item) => {
                                    return (
                                        <>
                                            <div className="cancel-rule-desc-item">
                                                <div className="cancel-rule-item-label">{item.day}天内取消， 扣{item.rate}%</div>
                                            </div>
                                        </>
                                    )
                                })}
                            </div>
                        </div>
                        <div id="rest_desc" className="canting">
                            <div className="canting-title">餐厅说明</div>
                            <div className="canting-content" dangerouslySetInnerHTML={{ __html: detail?.restaurant_instruction }}>
                                {/* {detail?.restaurant_instruction?.split('\n').map(v => {
                                    return <div>{v}</div>
                                })} */}
                            </div>
                        </div>
                        {
                            visitList.length > 0 && <div id="visit_desc" className="canting">
                                <div className="canting-title">探店报道</div>
                                <div className="canting-content">
                                    {
                                        visitList?.map(v => {
                                            return <div className="exploreInfo" onClick={() => {
                                                // 使用 window.open 方法在新页面打开链接
                                                window.open(`/visitReport?id=${v.id}`, '_blank');
                                            }}>
                                                <img src={Config.imgPrefix + v?.visit_pic} className="cover" mode="aspectFill" />
                                                <div className="infoValue">
                                                    <div className="tit">{v?.visit_title}</div>
                                                    <div className="value" dangerouslySetInnerHTML={{ __html: v?.visit_intro?.replace(/ /g, '&nbsp;').replace(/\n|↵/g, '<br/>') }}>

                                                    </div>
                                                </div>
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                        }

                    </div>



                </div>

            </div>

            <div className="tool-big-box">
                <div className="tool-box">
                    <div className="save-box">
                        {
                            !!detail?.collect ? <img src={save_f} alt="" className="icon" onClick={() => collectFn(0)} /> : <img src={save} alt="" className="icon" onClick={() => collectFn(1)} />
                        }
                        <div>收藏</div>
                    </div>
                    <div className="subscription-box">
                        <div className="subscription-price">预约费：{detail.subscription_price}元/人</div>
                        <button
                            style={{
                                width: "160px",
                                height: "48px",
                                background: '#C59D60',
                                border: 'none',
                                color: '#FFFFFF',
                                fontSize: '18px',
                                borderRadius: '4px',
                            }}
                            type="button"
                            onClick={
                                () => {
                                    if (!getUser()) {
                                        navigate("/login")
                                        return
                                    }
                                    if (!JSON.parse(sessionStorage.getItem('user'))?.last_name||!JSON.parse(sessionStorage.getItem('user'))?.mobile||!JSON.parse(sessionStorage.getItem('user'))?.email) {
                                        navigate('/improveInfo?typ=2')
                                        return
                                    }
                                    navigate('/subOrderForm?id=' + detail.id, detail)
                                }
                            }
                        >
                            预约餐厅
                        </button>
                    </div>
                </div>
            </div>

        </div>
    )
}
